import { ParameterListValueTypeEnumSchema } from "@/Enums/ParameterListValueType";
import { z } from "zod";

export const ReportExecutionHistoryParameterValueDtoSchema = z.object({
    value: z.union([z.string(), z.number()]).nullable(),
    listValueType: ParameterListValueTypeEnumSchema.nullable(),
});

export type ReportExecutionHistoryParameterValueDto = z.infer<typeof ReportExecutionHistoryParameterValueDtoSchema>;